import React from 'react';
import LandingHeader from '../../components/LandingHeader/LandingHeader';
import LandingFooter from '../../components/LandingFooter/LandingFooter';
import SubPageHero from '../../components/SubPageHero/SubPageHero';
import Seo, { SITE_URL } from '../../components/Seo/Seo';
import { NewsGrid } from './newsComponents';
import { usePublishedPosts } from './useNews';
import './Landing.css';
import './News.css';

export const NEWS_TITLE = 'News & Updates | Qentoros';
export const NEWS_DESCRIPTION =
  'The latest news from Qentoros — BIO-PLY™ milestones, clinical research, regulatory progress, and company announcements.';

export default function News() {
  const { posts, loading } = usePublishedPosts('/news');

  return (
    <div className="landing-page">
      <Seo
        title={NEWS_TITLE}
        description={NEWS_DESCRIPTION}
        path="/news"
        // Unlinked until a post is live, so keep the empty page out of search.
        noindex={!loading && posts.length === 0}
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'Blog',
          name: 'Qentoros News',
          url: `${SITE_URL}/news`,
          description: NEWS_DESCRIPTION,
        }}
      />
      <LandingHeader />

      <main id="main" tabIndex={-1}>
        <SubPageHero
          eyebrow="News & updates"
          title="News from Qentoros"
          subtitle="Milestones, research and announcements from the team behind BIO-PLY™."
        />

        <section className="news-section" aria-label="All news">
          {loading && posts.length === 0 ? (
            <div className="news-grid" aria-busy="true" aria-label="Loading news">
              <div className="news-skeleton" />
              <div className="news-skeleton" />
              <div className="news-skeleton" />
            </div>
          ) : posts.length === 0 ? (
            <div className="news-empty">
              <h2>No news yet</h2>
              <p>Check back soon for updates from the Qentoros team.</p>
            </div>
          ) : (
            <NewsGrid posts={posts} headingLevel="h2" />
          )}
        </section>
      </main>

      <LandingFooter />
    </div>
  );
}
